import environment from './base'
import { externalConfig } from './external-config'
import merge from 'lodash.merge'

const env = environment()
export default merge(env, externalConfig)
